export const DATE_FORMAT_DAY_WITH_DATE_AND_TIME = "LLLL";
export const DATE_FORMAT_DD_MM_YYYY = "DD-MM-YYYY";
export const DATE_FORMAT_MAIL = "D MMMM YYYY";
export const DATE_FORMAT_DAY_WITH_DATE = "dddd D MMMM YYYY";